'use client';

import type { ReactElement } from 'react';
import { Switch } from '@/components/ui/switch';

export type RefineBooleanToggleProps = {
    label: string;
    attributeId: string;
    value: string;
    isFilterSelected: (attributeId: string, value: string) => boolean;
    toggleFilter: (attributeId: string, value: string) => void;
    isPending: boolean;
};

export default function RefineBooleanToggle({
    label,
    attributeId,
    value,
    isFilterSelected,
    toggleFilter,
    isPending,
}: RefineBooleanToggleProps): ReactElement {
    const checked = isFilterSelected(attributeId, value);

    return (
        <div className="flex items-start gap-2 border-b border-neutral-80 py-6">
            <span className="body-copy-m flex-1 font-bold text-neutral-10">{label}</span>
            <Switch
                checked={checked}
                disabled={isPending}
                onCheckedChange={() => toggleFilter(attributeId, value)}
                aria-label={label}
            />
        </div>
    );
}
